const SURVEYS_UPDATED = (state, surveys) => {
  state.surveys = surveys
}

export default {
  SURVEYS_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/productData/mutations.js